import { render, staticRenderFns } from "./mistakeRecord2024.vue?vue&type=template&id=064cadb2&scoped=true&"
import script from "./mistakeRecord2024.vue?vue&type=script&lang=js&"
export * from "./mistakeRecord2024.vue?vue&type=script&lang=js&"
import style0 from "./mistakeRecord2024.vue?vue&type=style&index=0&id=064cadb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064cadb2",
  null
  
)

export default component.exports